'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.ForschungsprojektSchema = {
  title: 'Forschungsprojekt',
  type: 'object',
  properties: Object.assign({}, baseProperties, {
    projektBeginn: {
      type: 'string',
      format: 'date-time'
    },
    projektEnde: {
      type: 'string',
      format: 'date-time'
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/forschungsprojekt.js
// module id = WMJ6
// module chunks = 0